import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Badge, IconButton, alpha, useTheme } from "@mui/material";

interface WooCartTriggerButtonProps {
  draftItemCount: number;
  onOpenCart: () => void;
}

/** Botão pedido em andamento — ícone circular + badge de quantidade. */
export function WooCartTriggerButton({
  draftItemCount,
  onOpenCart,
}: WooCartTriggerButtonProps) {
  const theme = useTheme();

  return (
    <IconButton
      onClick={onOpenCart}
      aria-label={
        draftItemCount > 0
          ? `Abrir pedido em andamento, ${draftItemCount} itens`
          : "Abrir pedido em andamento"
      }
      sx={{
        width: 44,
        height: 44,
        flexShrink: 0,
        border: `1px solid ${alpha(theme.palette.primary800.main, 0.2)}`,
        bgcolor: alpha(theme.palette.primary800.main, 0.04),
        "&:hover": {
          bgcolor: alpha(theme.palette.primary800.main, 0.08),
          borderColor: alpha(theme.palette.primary800.main, 0.35),
        },
      }}
    >
      <Badge
        badgeContent={draftItemCount}
        color="primary"
        overlap="circular"
        invisible={draftItemCount <= 0}
      >
        <ShoppingCartOutlinedIcon color="primary" />
      </Badge>
    </IconButton>
  );
}
